// Star rating icons (Cloudflare R2) + half-star resolution helper.
const R2_COMMON = 'https://assets.askhippo.co.za/Icons/common';

export const StarFullIcon = `${R2_COMMON}/star_full.svg`;
export const StarHalfIcon = `${R2_COMMON}/star_half.svg`;
export const StarEmptyIcon = `${R2_COMMON}/star_empty.svg`;

/**
 * Returns the icon for a single star at a given 1-based position, based on a
 * (possibly fractional) score.
 *
 * A half star is shown when the score's fractional part falls between 0.3 and
 * 0.7 (inclusive); below 0.3 the star is empty, above 0.7 it is full.
 *
 * @param {number} position 1-based star position (1-5).
 * @param {number} score The rating value, e.g. 4.5.
 * @param {{ full?: string, half?: string, empty?: string }} [icons] Optional
 *   icon overrides (e.g. the homepage uses a custom full-star asset).
 */
export const getStarIcon = (
  position,
  score,
  { full = StarFullIcon, half = StarHalfIcon, empty = StarEmptyIcon } = {}
) => {
  const value = Number(score) || 0;
  const floor = Math.floor(value);
  const fraction = value - floor;

  if (position <= floor) return full;
  if (position === floor + 1) {
    if (fraction > 0.7) return full;
    if (fraction >= 0.3) return half;
  }
  return empty;
};
